<template>
    <div class="package-diff shadow-lg">
        <div class="absolute -z-[1] left-0 top-0 right-0 bottom-0 h-full w-full bg-black bg-opacity-50"></div>
        <component :is="usageType === UpgradeUsageType.ONBOARDING ? OnboardingPackageDiff : EditionPackageDiff" :usageType="usageType" :useWhere="useWhere" @close="handleClose" />
    </div>
</template>

<script setup lang="ts">
import OnboardingPackageDiff from './onboarding/OnboardingPackageDiff.vue';
import EditionPackageDiff from './edition/EditionPackageDiff.vue';
import type { UsageAmountWhere } from '../constants';
import { UpgradeUsageType } from '../constants';
import type { EditionUpgradeAction } from '../types';

defineProps<{
    usageType: UpgradeUsageType,
    useWhere: UsageAmountWhere,
}>();

const emits = defineEmits<{
    (event: 'close', action: EditionUpgradeAction): void
}>();

function handleClose(action: EditionUpgradeAction) {
    emits('close', action);
}
</script>
<style lang="scss">
.edition-upgrade-wrap {
    @apply flex justify-center items-center absolute top-0 w-full h-screen z-[1000];
}
.try-experience {
    @apply relative;
    &::before {
        @apply content-[''] absolute top-1/2 -left-5 w-5 h-px bg-black;
    }
    &::after {
        @apply content-[''] absolute top-1/2 -right-5 w-5 h-px bg-black;
    }
}
</style>
